import(/* webpackMode: "eager", webpackExports: ["PricingPageClient"] */ "/vercel/path0/src/app/pricing/PricingPageClient.tsx");
